import ConfigConnected from '@clearkit/icons/indicators/ConfigConnected';
import { CKBox, CKMultilineTextField, CKTextField } from '@clearkit/react';
import capitalize from 'lodash/capitalize';

const WebhookConfigCard = ({
  objectType,
  currentAccount,
  accountConnector,
}) => {
  const webHookUrl = `https://marketo-webhooks.clearbit.com/v1/marketo/webhooks?clearbit_account_id=${currentAccount.id}&account_id=${accountConnector.remoteMeta.serviceId}&object_type=${objectType}&id={{${objectType}.Id}}&email={{${objectType}.Email Address}}&first_name={{${objectType}.First Name}}&last_name={{${objectType}.Last Name}}&anonymous_ip={{${objectType}.Anonymous IP}}`;
  return (
    <CKBox className="w-6/12 h-full max-w-md p-4 space-y-4" variant="card">
      <div className="py-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="flex-shrink-0 rounded-full">
              <ConfigConnected />
            </div>
            <div className="text-black">
              <p className="text-sm font-medium capitalize">
                Receiving Webhooks
              </p>
              <p className="text-sm opacity-75">
                New {capitalize(objectType)} Enrichment Enabled
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <label htmlFor="url" className="block mb-1 text-sm text-gray-700">
            Webhook URL
          </label>
          <CKMultilineTextField
            className="w-full"
            rows={4}
            readOnly
            data-testid="webhookUrl"
            name="url"
            value={webHookUrl}></CKMultilineTextField>
        </div>

        <div>
          <label
            htmlFor="requestType"
            className="block mb-1 text-sm text-gray-700">
            Webhook Request Type
          </label>
          <CKTextField
            className="w-full"
            id="requestType"
            name="requestType"
            readOnly
            data-testid="requestType"
            value="GET"
            type="text"
            placeholder="Enter value"
          />
        </div>
        <div>
          <label
            htmlFor="responseType"
            className="block mb-1 text-sm text-gray-700">
            Webhook Response Type
          </label>
          <CKTextField
            className="w-full"
            id="responseType"
            name="responseType"
            data-testid="responseType"
            readOnly
            type="text"
            value="None"
            placeholder="Enter value"
          />
        </div>

        <hr className="border-gray-100" />
        <div>
          <label className="block mb-1 text-sm text-gray-700" htmlFor="header">
            Webhook Header
          </label>
          <CKTextField
            className="w-full"
            id="header"
            name="header"
            value="Authorization"
            data-testid="webhookHeader"
            readOnly
            type="text"
          />
        </div>
        <div>
          <label className="block mb-1 text-sm text-gray-700" htmlFor="value">
            Webhook Authorization Header Value
          </label>
          <CKTextField
            className="w-full"
            id="value"
            name="value"
            data-testid="webhookHeaderValue"
            value={`Bearer ${accountConnector.webhookPassword}`}
            readOnly
            type="text"
          />
        </div>
      </div>
    </CKBox>
  );
};

export default WebhookConfigCard;
